module.exports = __webpack_public_path__ + "static/img/EP202504081424412.bf4a975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424412.jpg
// module id = r11Z
// module chunks = 1